/* eslint-disable consistent-return */
export const bucketFetchManifest = async (res, keycloak) => {
  const archivesRes = res.documentarchives[0];
  const archivesResURL = archivesRes === null || archivesRes === void 0 ? void 0 : archivesRes.url;
  const url = `${process.env.REACT_APP_BUCKET_GATEWAY_URL}/${archivesResURL}`;

  if (url && archivesResURL) {
    const headers = new Headers();

    if (keycloak && !(keycloak !== null && keycloak !== void 0 && keycloak.token)) {
      keycloak.logout();
      return;
    } // clinical server takes keycloak as separate header,
    // everything else uses it as a bearer token


    const tokenExpirytime = parseInt(process.env.REACT_APP_TOKEN_VALIDITY_IN_SECONDS);

    if (keycloak) {
      let html = '';
      await keycloak.updateToken(tokenExpirytime);
      headers.set('Authorization', `Bearer ${keycloak.token}`);
      await fetch(`${url}`, {
        headers,
        credentials: 'same-origin'
      }).then(async response => {
        if (response.ok && response.status === 200) {
          const decoder = new TextDecoder('utf-8');
          const reader = response.body.getReader();
          await reader.read().then(async function processText({
            done,
            value
          }) {
            if (done) {
              return;
            }

            html += decoder.decode(value);
            reader.read().then(processText);
          });
        }

        return null;
      }).catch(err => 'There was an error');
      const bucketRes = await fetchStorage(html);
      return bucketRes;
    }
  }
};
export const fetchStorage = async url => {
  if (url) {
    const headers = new Headers();
    headers.set('Content-Type', `text/plain`);
    let html = '';
    let htmlRes = '';
    await fetch(`${url}`, {
      headers,
      credentials: 'same-origin'
    }).then(async response => {
      if (response.ok && response.status === 200) {
        const decoder = new TextDecoder('utf-8');
        const reader = response.body.getReader();

        while (true) {
          // eslint-disable-next-line no-await-in-loop
          const {
            done,
            value
          } = await reader.read();

          if (done) {
            htmlRes = html; // Do something with last chunk of data then exit reader

            return;
          }

          html += decoder.decode(value);
        }
      }
    }).catch(err => 'There was an error');
    const htmlres = getArchiveJson(htmlRes);
    return htmlres;
  }

  return null;
};

const getArchiveJson = gApi => {
  let resGApi = gApi;

  if (typeof gApi === 'string') {
    const parsedGApi = JSON.parse(gApi);

    if (parsedGApi && parsedGApi.length && parsedGApi.length === 1) {
      const gApiAns = parsedGApi[0];

      if (Array.isArray(gApiAns)) {
        resGApi = JSON.stringify(gApiAns);
      }
    }
  }

  return resGApi;
};